// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"c8ee5066","107":"d9627386","218":"3d70c70f","249":"641abb09","535":"e9b50710","664":"5fe52488","985":"188db3f4"}[chunkId] + ".chunk.js";
};